export default "__VITE_ASSET__C9WRLJIs__"